var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.modal && _vm.modal.open)?_c('div',[(_vm.modal.type === 'move-attachment')?_c('EmailAttachmentModal',{attrs:{"items":_vm.modal.item}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }